//M10-11344 Po related design changes
import { Autocomplete, Button } from "src/components";
import { RootState } from "src/context/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { poActions } from "src/context/po-slice";
import { generatePo, getCompanyList, getStateList } from "src/services/po-api";
import { usePoHandlers } from "./PoController";
import MultiAutocompleteAsync from "src/components/ui/MultiAutocompleteAsync";
import { useToast } from "src/hooks/useToast";
import FormSuccess from "../../container/FormSuccess";
import Loader from "../../components/Loader";

const PoGenerate = () => {
    const dispatch = useDispatch();
    const { poFiltersData, poFilters } = useSelector((state: RootState) => state.po);
    const [isGeneratingPo, setIsGeneratingPo] = useState(false);
    const [openGeneratePoModal, setOpenGeneratePoModal] = useState(false);
    const [filtersCleared, setFiltersCleared] = useState(false);

    useEffect(() => {
        const init = async () => {
            handleResetFilters();
            setFiltersCleared(true);
        };
        init();
    }, []);

    const { toast } = useToast();

    const {
        fetchStockist,
        fetchOrders,
        fetchDivision,
        fetchProduct,
        fetchCounter,
        handleResetFilters,
        companyHandler,
        stateHandler,
        stockistHandler,
        orderHandler,
        divisionHandler,
        productHandler,
        counterHandler,
    } = usePoHandlers();


    const handlePoGenerate = async () => {
        if (!poFilters?.company?.code) {
            toast({ description: "Please select company", variant: "destructive" });
            return;
        }
        if (!poFilters?.soType?.code) {
            toast({ description: "Please select SO type", variant: "destructive" });
            return;
        }
        setIsGeneratingPo(true);
        const payload = {
            company_short_code: poFilters?.company?.shortcode,
            company_code: poFilters?.company?.code,
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            po_generatetype: poFilters?.soType?.code
        }
        try {
            const res = await generatePo(payload);
            toast({ description: "PO generation requested successfully", variant: "default" });
            if (res?.data?.success == true) {
                handleResetFilters();
            }
        } catch (error: any) {
            toast({ description: error?.response?.data?.message || "Something went wrong", variant: "destructive" });
        } finally {
            setIsGeneratingPo(false);
        }
    }

    useEffect(() => {
        if (!poFiltersData?.company?.length) {
            getCompanyList()
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "company", value: res?.data })))
                .catch((err) => console.log(err));

        }
        if (!poFiltersData?.state?.length) {
            getStateList()
                .then((res) => dispatch(poActions.setPoFiltersData({ key: "state", value: res?.data?.data })))
                .catch((err) => console.log(err));
        }
    }, [dispatch]);

     if (!filtersCleared) return <Loader />;

    return (
        <>
            <div>
                <div className="flex justify-between items-center gap-2">
                    <div className="flex gap-2 w-[85%] [@media(min-width:1580px)]:w-[85%]">
                        <Autocomplete
                            onSelectionChange={companyHandler}
                            placeholder="Company"
                            inputClassName="w-fit"
                            suggestionList={poFiltersData?.company || []}
                            displayKey="name"
                            defaultValue={poFilters?.company}
                            uniqueKey="code" />
                        <Autocomplete
                            onSelectionChange={(value: any) => dispatch(poActions.setPoFilters({ key: "soType", value: value }))}
                            placeholder="SO Type"
                            inputClassName="w-fit"
                            suggestionList={[
                                {
                                    name: 'Regular',
                                    code: 'Regular',
                                },
                                {
                                    name: 'SAO',
                                    code: 'SAO',
                                },
                                {
                                    name: 'CNRP',
                                    code: 'CNRP',
                                },
                                {
                                    name: 'CNSH',
                                    code: 'CNSH',
                                },
                                {
                                    name: 'SHPO',
                                    code: 'SHPO',
                                }
                            ]}
                            displayKey="name"
                            defaultValue={poFilters?.soType}
                            uniqueKey="code" />

                        {/* <div className="border border-[#E5E5E5] rounded-lg max-h-[35px] flex items-center">
                            <div className="p-2 text-gray-400">
                                Date:
                            </div>
                            <DatePickerWithRange className="" date={poFilters?.dateRange || dateRange} dateRangeHandler={dateRangeHandler} />
                        </div> */}
                        <MultiAutocompleteAsync
                            placeholder="States"
                            inputClassName="w-fit"
                            suggestionList={poFiltersData?.state || []}
                            controlledValue={poFilters?.state}
                            displayKey="state_name"
                            uniqueKey="state_code"
                            defaultValue={poFilters?.state}
                            onSelectionChange={stateHandler}
                            showSelectAll={true}
                        />
                    </div>
                    <div className="flex gap-2">
                        <Button disabled={isGeneratingPo} isLoading={isGeneratingPo} loaderSize="small" className="font-normal text-white bg-[#8051FF]"
                            onClick={() => setOpenGeneratePoModal(true)}>
                            Generate PO
                        </Button>
                        <Button disabled={isGeneratingPo} onClick={handleResetFilters} className="font-normal text-black bg-[#F1F1F1]">
                            Reset
                        </Button>
                    </div>
                </div>
                <div className="mt-1 w-[70%] flex items-center gap-2 [@media(min-width:1580px)]:w-[70%]">

                    <MultiAutocompleteAsync
                        placeholder="Stockists"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.stockist || []}
                        displayKey="stockist_name"
                        uniqueKey="company_stockist_code"
                        controlledValue={poFilters?.stockist}
                        defaultValue={poFilters?.stockist}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchStockist : undefined}
                        onSelectionChange={stockistHandler}
                        showSelectAll={true}
                        additionalDisplayKey={true}
                        additionalDisplayKeySearch="company_stockist_code"
                        showSecondaryDisplayKey={true}
                        secondaryDisplayKey="company_stockist_code"
                    />
                    <MultiAutocompleteAsync
                        placeholder="Orders"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.orders || []}
                        displayKey="order_code"
                        uniqueKey="order_id_int"
                        defaultValue={poFilters?.orders}
                        controlledValue={poFilters?.orders}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchOrders : undefined}
                        onSelectionChange={orderHandler}
                        showSelectAll={true}
                    />
                    <MultiAutocompleteAsync
                        placeholder="Divisions"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.division || []}
                        displayKey="division_name"
                        uniqueKey="company_divisioncode"
                        defaultValue={poFilters?.division}
                        controlledValue={poFilters?.division}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchDivision : undefined}
                        onSelectionChange={divisionHandler}
                        showSelectAll={true}
                    />

                    <MultiAutocompleteAsync
                        placeholder="Products"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.products || []}
                        displayKey="item_description"
                        uniqueKey="item_code"
                        defaultValue={poFilters?.products}
                        controlledValue={poFilters?.products}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchProduct : undefined}
                        onSelectionChange={productHandler}
                        showSelectAll={true}
                    />
                    <MultiAutocompleteAsync
                        placeholder="Counters"
                        inputClassName="w-fit"
                        suggestionList={poFiltersData?.counters || []}
                        displayKey="counter_name"
                        uniqueKey="counter_code"
                        defaultValue={poFilters?.counters}
                        controlledValue={poFilters?.counters}
                        isAsyncQuery={true}
                        asyncListFunction={poFilters?.company?.code ? fetchCounter : undefined}
                        onSelectionChange={counterHandler}
                        showSelectAll={true}
                    />
                </div>
            </div>
            <FormSuccess
                onCloseModal={() => {
                    setOpenGeneratePoModal(false)
                }}
                showForm={openGeneratePoModal}
                onContinue={() => {
                    setOpenGeneratePoModal(false)
                    handlePoGenerate();
                }}
                variant=""
                popupMessage={{
                    description: `Are you sure you want to generate PO for ${poFilters?.company?.name}?`,
                    title: "Generate PO!",
                }}
                enableBackButton={true}
            />
        </ >
    );
};

export default PoGenerate;
//M10-11344 Po related design changes